window.__PARFUMADO_PROXY_LOCALES__ = {
  "chords": {
    "fris": {
      "title": "Fris",
      "description": "Akkoord dat aangeeft dat er houtige materialen in voorkomen; voornamelijk uit bomen, maar ook uit bosjes en soorten grassen. Vaak zelfverzekerde en energieke parfums."
    },
    "houtachtig": {
      "title": "Houtachtig",
      "description": "Akkoord dat aangeeft dat er houtige materialen in voorkomen; voornamelijk uit bomen, maar ook uit bosjes en soorten grassen. Vaak zelfverzekerde en energieke parfums."
    },
    "amber": {
      "title": "Amber",
      "description": "Amber creert warme, volle, zonnige, vaak sensuele geuren.  Door velen geliefd vanwege  charmante karakter."
    },
    "balsemachtig": {
      "title": "Balsemachtig",
      "description": "Balsemachtige geuren lenen zichzelf graag voor koudere jaargetijden en kenmerken zich met een warm, majesteus en pluchen karakter."
    },
    "leder": {
      "title": "Leder",
      "description": "Populaire geurnoot die sterk doet denken aan lederen dierenhuiden en lederwaar. Primitief en sensueel tegelijk."
    },
    "rokerig": {
      "title": "Rokerig",
      "description": "Rokerige geuren roepen knusse sferen op; een uitgeblazen kaars, rondgaande whiskey bij een kampvuur of een vanille pijptabak. "
    },
    "zoet": {
      "title": "Zoet",
      "description": "Zoete geurnoten kunnen worden geassocieerd met noten als honing, cocolade, vanille of snoepzoet."
    },
    "kruidig": {
      "title": "Kruidig",
      "description": "Kruidige geuren behoren tot de orienteaalse familie en dragen vaak noten van exotische plekken van de wereld met zich mee. Denk aan kaneel, vanille, peper, nootmuskaat en dergelijke."
    },
    "fris-kruidig": {
      "title": "Fris Kruidig",
      "description": "Kruidige geuren behoren tot de orienteaalse familie en dragen vaak noten van exotische plekken van de wereld met zich mee. Denk aan kaneel, vanille, peper, nootmuskaat en dergelijke."
    },
    "aromatisch": {
      "title": "Aromatisch",
      "description": "Combinaties van lavendel, salie, rozemarijn en andere planten met een intens kruidig-grassig aroma, vaak aangevuld met citrusachtige noten, geven een speciaal karakter aan de levendige aromatische familie."
    },
    "citrus": {
      "title": "Citrus",
      "description": "Citrusparfums zijn stimulerende, frisse geuren, zoals eau de colognes, en hebben uitgesproken noten van limoen, bergamot, mandarijn, of sinaasappel."
    },
    "poederig": {
      "title": "poederig",
      "description": "Poederige geuren  geven je  het gevoel van retro gezichtspoeder en het klassieke talkpoeder. De meeste poederige geuren dragen iris, violet, vanille, rozen of musk met zich."
    },
    "vanille": {
      "title": "Vanille",
      "description": "De groene platte peulen van de vanillebladeren bevatten  zwarte zaadjes met een intense, warme, zachte , balsemachtige geur die lang houdt."
    },
    "zacht-kruidig": {
      "title": "Zacht Kruidig",
      "description": "Kruidige geuren behoren tot de orienteaalse familie en dragen vaak noten van exotische plekken van de wereld met zich mee. Denk aan kaneel, vanille, peper, nootmuskaat en dergelijke."
    },
    "witte-bloemen": {
      "title": "Witte Bloemen",
      "description": "Een subgroep in de bloemen familie; denk hierbij aan oranje bloesem, jasmijn en tuberozen. De groep kenmerkt zich meestal met een zoet-bloemige geur."
    },
    "tuberose": {
      "title": "Tuberose",
      "description": "De tuberose ruikt bloemig, jasmijn-achtig en honingachtig.  Ook kan het een dierlijk accent hebben.  "
    },
    "bloemig": {
      "title": "Bloemig",
      "description": "Parfumeurs stellen als het ware vaak een boeket samen in een parfum, een soort symphonie. De combinatie van witte bloemen en de klassieke combinatie van roos, jasmijn & ylang-ylang zijn hierbij zeer geliefd."
    },
    "fruitig": {
      "title": "Fruitig",
      "description": "Algemene classificatie van frisse, zoete, sappige geurnoten die linken naar eetbare fruitsoorten."
    },
    "warm-kruidig": {
      "title": "Warm Kruidig",
      "description": "Kruidige geuren behoren tot de orienteaalse familie en dragen vaak noten van exotische plekken van de wereld met zich mee. Denk aan kaneel, vanille, peper, nootmuskaat en dergelijke."
    },
    "honing": {
      "title": "Honing",
      "description": "Zoete, eetbare, gouden voorjaarsnoot die zeer herkenbaar ruikt en sterk doet denken aan de zoete, gouden honing zoals we deze kennen."
    },
    "oudh": {
      "title": "Oudh",
      "description": "Oud is een hars van de Aquilara-boom. De redelijk zware geur kan  verschillende aroma's hebben, afhankelijk van de kwaliteit en  verwerkingstechnieken: van houtig tot zoet balsemachtig."
    },
    "aldehydisch": {
      "title": "Aldehydisch",
      "description": "De meeste aldehyden hebben een erg sterke geur met een licht vettig, waxy karakter met een ijle, haast metalige twist. Andere aldehydes kunnen ook een citrus, mandarijnachtige geur of een rozig akkoord verspreiden."
    },
    "amandel": {
      "title": "Amandel",
      "description": "Zachte, eetbare, sappige en bitterzoete noot die vaak geflankeerd wordt door vanille en heliotrope noten."
    },
    "rozen": {
      "title": "Rozen",
      "description": "Rozen ruiken zacht, delicaat, bloemig, honigachtig rijk en zoet. De olie wordt heel veel gebruikt in parfums en is vaak terug te vinden in het hart van een parfum. Het brengt een krachtige en delicate geur mee."
    },
    "patchouli": {
      "title": "Patchouli",
      "description": "Patchouli ruikt houtachtig, naar natte aarde en groene bladeren. Het heeft een donker karakter en brengt diepte en sensualiteit in parfums. "
    },
    "koffie": {
      "title": "Koffie",
      "description": "De koffie noot is intens en een donker gebrand facet van het parfum. De geur van een verse, goede kop koffie wordt gereproduceerd."
    },
    "musk": {
      "title": "Musk",
      "description": "Oorspronkelijk was dit de 'essence' van de klieren van het musk hert, tegenwoordig een beschermde diersoort. Wordt synthetisch nagemaakt en brengt sensualiteit en warmte aan een geur."
    },
    "aquatisch": {
      "title": "Aquatisch",
      "description": "Aquatische geuren hebben een sterke associatie met water: zoals de zee, watervallen, wind, transparant, fris, blauw en unisex."
    },
    "groen": {
      "title": "Groen",
      "description": "Groene geuren ruiken naar gekneusde bladeren, verse kruiden of gemaaid gras. "
    },
    "tabak": {
      "title": "Tabak",
      "description": "Rijk, genuanceerd, warm en zoetig afkomstig van de geweekte tabaksbladeren. "
    },
    "kers": {
      "title": "Kers",
      "description": "Populaire rode fruitnoot die zoetig en zurig tegelijk kan zijn. Komt voornamelijk in vrouwelijke parfums voor."
    },
    "aarde": {
      "title": "Aarde",
      "description": "Synthetische geurnoot die is geinspireerd op de natuurlijke geur van aarde. De aroma  voegt een 'aarde tint' aan de compositie toe."
    },
    "gele-bloemen": {
      "title": "Gele Bloemen",
      "description": "Parfumeurs stellen als het ware vaak een boeket samen in een parfum, een soort symphonie. De combinatie van witte bloemen en de klassieke combinatie van roos, jasmijn & ylang-ylang zijn hierbij zeer geliefd."
    },
    "kokos": {
      "title": "Kokos",
      "description": "Intense, tropische noot die tot een weelderige, zoete, melkachtige en zomerse verbeelding spreekt."
    },
    "melkachtig": {
      "title": "Melkachtig",
      "description": "Melkachtige geuren zijn warm en romig en doen sterk denken aan melk zoals we deze kennen."
    },
    "zee": {
      "title": "Zee",
      "description": "Zeenoten hebben het verfrissende van water en het ziltige van zeezout. Veel zomergeuren en limited editions bevatten dit ingrediënt."
    },
    "zand": {
      "title": "Zand",
      "description": "Amberachtige, zoete en zachte noot die het gevoel van kurkdroog zand of een strand reproduceert. Comfortabel en zonnig."
    },
    "cacao": {
      "title": "Cacao",
      "description": "Vol, sensueel, licht kruidig en ietwat bitters. Cacao geuren neigen sterk naar chocolade en hebben ook een licht vettige associatie."
    },
    "ozonisch": {
      "title": "Ozonisch",
      "description": "Ozonische parfums hebben een waterachtig karakter met een bescheiden opening. Ze zorgen voor een gevoel van luchtigheid en tederheid."
    },
    "maritiem": {
      "title": "Maritiem",
      "description": "Marine geurnoten voegen een helder, fris en natuurlijke touch toe aan parfums. Voorbeelden zijn zeewater, oceaanbries, algen, zeewier en zand. "
    },
    "rum": {
      "title": "Rum",
      "description": "Complex, zoet en aromatisch. Komt in zowel houtachtige geuren voor als in frisse, tropische parfums."
    },
    "kaneel": {
      "title": "Kaneel",
      "description": "Kaneel is een eeuwenoud, smaakvol specerij dat afkomstig is  van de kaneelboom. Het is zowel zoet en bitter als warm en sensueel tegelijk."
    },
    "dierlijk": {
      "title": "Dierlijk",
      "description": "De term 'dierlijk' refereert naar aromatische stoffen met een geur die doet denken aan dieren - zowel echte dieren als dierlijke instincten die mensen bezitten."
    },
    "karamel": {
      "title": "Karamel",
      "description": "Sensuele, rijke, romige en boterige geurnoot die de nodige zoetheid in parfums aanbrengt."
    },
    "zout": {
      "title": "Zout",
      "description": "Zout gaat goed samen met maritieme en houtachtige geuren, maar ook met fruit en vetiver. Gewaardeerd vanwege het ongewone effect in moderne composities."
    },
    "hazelnoot": {
      "title": "Hazelnoot",
      "description": "Noot met een gebalanceerde aroma die tussen houtachtig en zetmeelachtig in zit. Minder zoet dan amandel, met een romig karakter."
    },
    "orientaals": {
      "title": "Oriëntaals",
      "description": "Noot met een gebalanceerde aroma die tussen houtachtig en zetmeelachtig in zit. Minder zoet dan amandel, met een romig karakter."
    },
    "gourmand": {
      "title": "Gourmand",
      "description": "Noot met een gebalanceerde aroma die tussen houtachtig en zetmeelachtig in zit. Minder zoet dan amandel, met een romig karakter."
    },
    "oriental": {
      "title": "Oriental",
      "description": "Noot met een gebalanceerde aroma die tussen houtachtig en zetmeelachtig in zit. Minder zoet dan amandel, met een romig karakter."
    },
    "floral": {
      "title": "Floral",
      "description": "Noot met een gebalanceerde aroma die tussen houtachtig en zetmeelachtig in zit. Minder zoet dan amandel, met een romig karakter."
    },
    "fresh": {
      "title": "Fresh",
      "description": "Noot met een gebalanceerde aroma die tussen houtachtig en zetmeelachtig in zit. Minder zoet dan amandel, met een romig karakter."
    },
    "woody": {
      "title": "Woody",
      "description": "Noot met een gebalanceerde aroma die tussen houtachtig en zetmeelachtig in zit. Minder zoet dan amandel, met een romig karakter."
    }
  },
  "general": {
    "meta": {
      "tags": "Tagged \"{{ tags }}\"",
      "page": "Pagina {{ page }}"
    },
    "404": {
      "title": "Pagina niet gevonden",
      "subtext_html": "De door u opgevraagde pagina lijkt niet te bestaan. Klik <a href=\"\/collections\/all\">hier<\/a> om door te gaan naar het overzicht van al onze parfums."
    },
    "breadcrumbs": {
      "home": "Home",
      "home_link_title": "Terug naar homepage"
    },
    "newsletter_form": {
      "title": "Nieuwsbrief",
      "description": "Meld je aan voor onze nieuwsbrief",
      "newsletter_email": "ruiklekker@parfumado.com",
      "submit": "Verstuur",
      "confirmation": "Dank voor het aanmelden!"
    },
    "search": {
      "no_results_html": "Je zoekopdracht \"{{ terms }}\" heeft geen resultaten opgeleverd.",
      "results_for_html": "Je zoekopdracht \"{{ terms }}\" heeft het volgende opgeleverd:",
      "title": "Zoek producten op onze site",
      "placeholder": "Zoek parfum...",
      "submit": "Zoek",
      "all_scents": "Zie alle geuren",
      "all_scents_with": "Zie alle geuren",
      "all_scents_with_term": "met",
      "no_scents_with": "Geen geuren met de naam",
      "no_collections_found": "Geen collectie gevonden",
      "find_perfumes": "Zoek parfums..."
    },
    "filter": {
      "filter": "filter",
      "header_description": "Gebruik de filter om snel parfums te vinden die bij je passen. Weet je al wat je zoekt? Gebruik dan de zoekfunctie",
      "clear_selection": "Wis selectie",
      "clear": "Clear",
      "brand": "Merk",
      "gender": "Geslacht",
      "scent_associations": "Ingrediënten ",
      "style": "Stijl",
      "season": "Seizoen",
      "occasion": "Gelegenheid",
      "scent_families": "Geurfamilies",
      "type": "Type"
    },
    "collections": {
      "collection_header_description": "Gebruik de filter om parfums te vinden die bij je passen. Weet je al wat je zoekt? Gebruik dan de zoekfunctie"
    },
    "count": {
      "month_count": {
        "one": "{{ count }} maand",
        "other": "{{ count }} maanden"
      }
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "Gepubliceerd door {{ author }} op {{ date }}",
      "older_post": "Oudere berichten",
      "newer_post": "Nieuwere berichten",
      "tags": "Tags",
      "comment_meta_html": "{{ author }} op {{ date }}",
      "read_more": "Lees meer"
    },
    "comments": {
      "title": "Laat een bericht achter",
      "name": "Naam",
      "email": "Email",
      "message": "Bericht",
      "post": "Post bericht",
      "moderated": "Reacties moeten worden goedgekeurd voordat ze worden geplaatst",
      "success_moderated": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated.",
      "success": "Your comment was posted successfully! Thank you!",
      "with_count": {
        "one": "{{ count }} comment",
        "other": "{{ count }} comments"
      }
    },
    "sidebar": {
      "recent_articles": "Recente artikelen",
      "categories": "Categorieen"
    }
  },
  "survey": {
    "Start": {
      "label": "Ontdek nieuwe favoriete parfums",
      "note": "Doe onze quiz en ontdek welke geurfamilie én parfums het beste bij jou passen!",
      "button": "Start de quiz"
    },
    "Choose": {
      "brands": {
        "label": "Welke type parfummerken spreken je het meeste aan?",
        "prestige": "Luxe parfums van bekende parfummerken",
        "niche": "Niche perfumes van exclusieve parfummerken",
        "natural": "Vegan en duurzame parfummerken"
      },
      "ageCategory": {
        "label": "In welke leeftijdscategorie val je?",
        "parfumadoTip": "Door je leeftijd kunnen we beter je parfumvoorkeur begrijpen",
        "category_1": "16 - 25",
        "category_2": "26 - 35",
        "category_3": "36 - 45",
        "category_4": "46 - 65",
        "category_5": "66+"
      },
      "gender": {
        "parfumadoTip": "sta je open voor unisex parfums? geef dit aan in de volgende pagina.",
        "note": "Ik zoek een parfum voor:",
        "label": "Wat voor parfum zoek je?",
        "male": "Mannen",
        "female": "Vrouwen"
      },
      "unisex": {
        "parfumadoTip": "Unisex parfums zijn voor zowel mannen als vrouwen",
        "label": "Sta je open voor een unisex parfum?",
        "yes": "Ja",
        "no": "Nee"
      }
    },
    "SelectPerfumes": {
      "label": "Wat is je all time favoriete parfum?",
      "note": "Note",
      "parfumadoTip": "Let op: de merken die je hier selecteert zitten niet per se in ons assortiment. Deze parfums dienen als startpunt om jouw geurprofiel vast te stellen.",
      "similar": {
        "label": "Ben je op zoek naar een parfum dat:",
        "yes": "Lijkt op wat je al lekker vindt",
        "no": "Iets totaal anders"
      },
      "family": {
        "label": "Welke geurfamilie spreekt jou het meeste aan?",
        "note": "Kies max 1 favoriet",
        "fresh": "Fris",
        "rich": "Rijk & diep",
        "floral": "Bloemig",
        "woody": "Houtachtig",
        "oriental": "Kruidig",
        "gourmand": "Gourmand"
      },
      "subfamily": {
        "label": "Wat vind je het lekkerst ruiken?",
        "note": "Kies max 2 favorieten",
        "parfumadoTip": "Parfums zijn ingedeeld in geurfamilies. Kies de geurfamilie die jou het meeste aanspreekt"
      },
      "note_choice": {
        "label": "Naar wat voor parfums ben je op zoek?",
        "light": "Frisse, sprankelende parfums",
        "heavy": "Vollere, rijkere parfums"
      }
    },
    "Recommendations": {
      "content": "Jouw gekozen lievelingsparfum <b>{{ name }}<\/b> valt in geurfamilie <b>{{ family }}<\/b>. Mensen die houden van dit parfum, houden vaak ook van <b>{{ recommendation_1 }}<\/b> (geurfamilie <b>{{ recommendation_1_family }}<\/b>). Op basis van jouw overige quiz antwoorden, moeten ook <b>{{ recommendation_2 }}<\/b> (geurfamilie <b>{{recommendation_2_family}}<\/b>) en <b>{{ recommendation_3 }}<\/b> (geurfamilie <b>{{ recommendation_3_family }}<\/b>) jou aanspreken. Zij matchen het best met jouw overige voorkeuren.",
      "heading": "Jouw persoonlijke geurprofiel bestaat uit:",
      "favorites": "Favoriete geurfamilie(s):",
      "notification": "Door jouw reviews worden onze aanbevelingen voor jou steeds beter. Het helpt ons dus al je de parfums die je al kent meteen wilt reviewen. En de parfums die je gaat proberen uiteindelijk ook. Dank!",
      "fragranceFamilies": {
        "floral": {
          "description": "Parfums waar een of meerdere bloemen de hoofdrol spelen. Sommige parfums uit deze familie geven dat typische poederige, zepige gevoel. Gecombineerd met zoete harsen en specerijen krijgen parfums een oriëntaalse touch."
        },
        "woody": {
          "description": "Parfums met houtachtige tonen, leer of tabak. Denk aan vetiver, cedarwood en sandalwood. Mossige bossen, de geur van brandend hout, of subtieler, gecombineerd met citrus voor een frisser gevoel."
        },
        "fresh": {
          "description": "Citrus, fruitig, groen of aquatisch: zoveel vormen van frisse parfums die in deze geurfamilie vallen. Van frisse aquatische parfums tot groene parfums tot bergamot... Houd je van fris, ontdek dan deze familie."
        },
        "oriental": {
          "description": "Oriëntaalse parfums zijn kruidige, warme geuren. Sensuele, wat zwaardere mixen met oriëntaalse harsen, weelderige bloemen, vanille en musk."
        }
      },
      "perfumesSection": {
        "heading": "Welke parfums passen bij mijn geurprofiel?",
        "description": "Dit zijn onze aanbevelingen. Voeg ze hier toe aan je parfumkalender",
        "addToCalendar": "Voeg toe"
      }
    },
    "Submit": {
      "label": "We zijn je resultaten aan het analyseren..."
    },
    "General": {
      "greeting": "Leuk je te ontmoeten {{ name }}!",
      "back": "Terug",
      "next": "Volgende",
      "send": "Verstuur",
      "skip": "Sla over",
      "select": "Selecteer parfum",
      "search": "Zoek hier je parfum",
      "empty": "Geen parfum gevonden"
    },
    "Subfamilies": {
      "floral": "Vers geplukte bloemen",
      "soft_floral": "Zepig, poederig, musk",
      "floral_oriental": "Sinaasappelbloesem, oosterse bloemen",
      "woody_oriental": "Hout en kruiden",
      "soft_oriental": "Kaneel en saffraan",
      "woods": "Hout, vuur",
      "mossy_woods": "Groen bos, aarde, mos",
      "dry_woods": "Leer, hout",
      "citrus": "Citrus, bergamot",
      "aromatic_fougere": "Lavendel, munt, tijm",
      "water": "Open zee",
      "green": "Gemaaid gras",
      "woody_soft_oriental": "Patchouli, kruiden, hout",
      "fruity": "Zoete en sappige perziken en peren"
    }
  },
  "cart": {
    "general": {
      "title": "Winkelwagen",
      "remove": "Verwijder",
      "note": "Extra bericht",
      "subtotal": "Subtotaal",
      "shipping_at_checkout": "Verzenden & BTW bij afrekenen inbegrepen",
      "update": "Update",
      "checkout": "Afrekenen",
      "empty": "Je winkelwagen is momenteel nog leeg.",
      "continue_browsing_html": "Ga door met winkelen <a href=\"\/collections\/all\">here<\/a>.",
      "close_cart": "Sluit winkelwagen",
      "savings_html": "Je bespaart {{ price }}",
      "reduce_quantity": "Verminder aantal met",
      "increase_quantity": "Verhoog aantal met"
    },
    "label": {
      "product": "Product",
      "price": "Prijs",
      "quantity": "Aantal",
      "total": "Totaal"
    }
  },
  "collections": {
    "general": {
      "all_of_collection": "Alles {{ collection }}",
      "no_matches": "Sorry, er zijn geen producten in deze voorraad",
      "link_title": "Doorzoek onze {{ title }} collectie",
      "grid_view": "Grid view",
      "list_view": "List view",
      "items_with_count": {
        "one": "{{ count }} item",
        "other": "{{ count }} items"
      }
    },
    "sidebar": {
      "tags": "Tags"
    },
    "sorting": {
      "title": "Sorteer",
      "featured": "Aanbevolen",
      "best_selling": "Bestverkopend",
      "az": "Alfabetisch, A-Z",
      "za": "Alfabetisch, Z-A",
      "price_ascending": "Prijs, laag naar hoog",
      "price_descending": "Price, hoog naar laag",
      "date_descending": "Datum, nieuw naar oud",
      "date_ascending": "Datum, oud naar nieuw"
    },
    "onboarding": {
      "modal_title": "This page will show all of your store's products",
      "no_products_html": "There are no products yet, but once you begin adding them they will show up here regardless if they are in a collection.",
      "add_product": "Voeg product toe"
    }
  },
  "contact": {
    "form": {
      "name": "Naam",
      "email": "Email",
      "phone": "Telefoon",
      "message": "Bericht",
      "send": "Stuur",
      "post_success": "Dank voor je bericht. We komen zo spoedig mogelijk bij je terug."
    }
  },
  "customer": {
    "account": {
      "title": "Mijn account",
      "subtitle": "Pas hier je eigen gegevens aan",
      "details": "Account details",
      "view_addresses": "Toon adressen",
      "return": "Terug naar mijn account overzicht",
      "start_now": "Start nu",
      "menu": {
        "overview": "Overzicht",
        "information": "Accountgegevens",
        "scent_profile": "Geurprofiel",
        "subscription": "Abonnement",
        "invite": "Nodig een vriend uit"
      },
      "gender": {
        "popup": {
          "title": "Beter advies",
          "description": "Om je betere parfumsuggesties te kunnen doen willen we je geslacht weten.",
          "empty": "Selecteer je geslacht",
          "yes": "Bevestig je keuze"
        }
      },
      "countdown": {
        "choice_made": "{{ first_name }}, heb je de juiste keuze al gemaakt?",
        "days": "dagen",
        "hours": "uren",
        "minutes": "minuten",
        "choice": "Nu te ontvangen parfum in {{ date }}:",
        "change": "Pas je parfumkeuze aan",
        "active": {
          "delivery_date": "Je bestelling wordt verzonden op {{ date }}",
          "can_change": "Je kunt je keuze nog wijzigen voor:",
          "cant_change": "Je kunt je keuze niet meer wijzigen."
        },
        "paused": {
          "title": "Jouw account staat op dit moment op gepauzeerd",
          "choice": "Als je je deze maand bedenkt, moet je je abonnement deze maand weer activeren en binnen {{ count }} dagen je parfumkeuze maken.",
          "locked": "Je keuze om deze maand te pauzeren is vastgezet. Je eerstvolgende verzenddatum is {{ date }}."
        },
        "inactive": {
          "delivery_date": "Je account is nog niet voltooid. De eerstvolgende verzenddatum is {{ date }}.",
          "call_to_action": "Wil je dat we je parfum naar je verzenden op {{ date }}?"
        }
      }
    },
    "scent_profile": {
      "title": "Jouw geurfamilie(s)",
      "recommendations": "Onze aanbevelingen",
      "empty": {
        "title": "Geurprofiel ontbreekt",
        "description": "Wij hebben jouw persoonlijke geurprofiel nog niet vast kunnen stellen! Doe onze quiz en ontdek de parfums die écht bij je passen."
      },
      "update": {
        "title": "Update geurprofiel",
        "description": "Parfums geprobeerd en toe aan nieuwe aanbevelingen? Doe onze quiz opnieuw, update je geurprofiel en ontvang nieuwe aanbevelingen."
      },
      "call_to_action": "DOE DE QUIZ"
    },
    "referral": {
      "overview": {
        "title": "Nodig je vrienden uit en kies uit mooie cadeau’s",
        "description": "Deel je persoonlijke code, geef je vrienden 50%  korting op hun eerste maand en ontvang voor iedere startende vriend de keuze uit te gekke cadeau’s.",
        "call_to_action": "Nodig vrienden uit"
      },
      "invite": {
        "title": "Deel je persoonlijke code en geef vrienden €7,50 korting op hun eerste maand.",
        "description1": "Voor élke vriend die via jouw code bij ons start kies jij uit één van deze cadeaus:",
        "line1": "Een gratis extra travelcase in kleur naar keuze (alle kleuren behalve silver en gold)",
        "line2": "Een gratis verrassingsparfum van de maand",
        "line3": "50% korting op je eerstvolgende maand",
        "description2": "Je cadeau wordt meegestuurd bij je eerstvolgende bestelling."
      },
      "faq": {
        "title": "Veelgestelde vragen",
        "question1": "Wat als ik meerdere vrienden in een maand aandraag?",
        "answer1": "Wat goed! Je mag nu meerdere cadeaus uitkiezen. Er kan slechts 1 cadeau per maand worden ingewisseld. Dit betekent dus dat je cadeaus over meerdere maanden verspreid zullen worden.",
        "question2": "Wat als ik het verrassingsparfum niet lekker vind?",
        "answer2": "Het is altijd een parfum dat met zorg is uitgekozen door onze experts en goede reviews heeft vanuit onze parfumado community. Mocht je het parfum niet lekker vinden, dan kun je het niet ruilen, want het is een extraatje naast je reguliere abonnement. Je kunt er hopelijk wel iemand anders mee blij maken! ",
        "question3": "Ik heb mijn code gedeeld, maar ik kan nog geen cadeau kiezen?",
        "answer3": "Om te kunnen kiezen uit cadeaus, moet jouw vriend(in) eerst een abonnement zijn gestart. Zodra dit is gebeurd, kun jij jouw cadeau keuze maken op jouw account pagina.",
        "question4": "Hoe kan een vriend(in) mijn persoonlijke kortingscode gebruiken voor de korting?",
        "answer4": "Je vriend(in) voert jouw unieke kortingscode in bij de check-out. Dit is nadat hij\/zij een account heeft aangemaakt. Wij krijgen hiervan een melding. En daarna zorgen we ervoor dat jij direct daarna een cadeau kunt uitkiezen in jouw account overzicht."
      },
      "share": {
        "title": "Of deel via",
        "copy": "Kopieer",
        "copied": "Gekopieerd!",
        "email": {
          "subject": "Korting op je eerste parfum",
          "line1": "Hi, even een leuke tip van mij.",
          "line2": "Ken je Parfumado al? Het is een te gek nieuw concept waarbij je iedere 4 weken een maandvoorraad parfum thuis ontvangt die je zélf uitkiest. Je kiest steeds opnieuw uit vrijwel alle mooie merken!",
          "line3": "Omdat ik al abonnee ben mag ik je 50% korting geven op je eerste bestelling! Ga naar https:\/\/parfumado.com en gebruik tijdens het bestellen deze promotiecode: {{ code }}",
          "line4": "Bij je eerste order ontvang je:",
          "option1": "- Spaardoosje",
          "option2": "- Travelcase",
          "option3": "- Parfum naar keuze",
          "line5": "Lijkt me echt iets voor jou!",
          "line6": "Groetjes en tot snel."
        },
        "social_media": "Ik heb een Parfumado kortingscode tvw €7,50! Met Parfumado ontvang je iedere maand een zelfgekozen parfum bij je thuis. Ga naar https:\/\/parfumado.com en gebruik tijdens het bestellen deze promotiecode: {{ code }}. Veel plezier!"
      },
      "reward": {
        "title": "Via jou aangedragen Parfumado vrienden: {{ count }}",
        "sort": "Verander de volgorde van je cadeau's door ze te slepen.",
        "popup": {
          "title": "Kies jouw gift!",
          "current_choice": "Je huidige gift keuze is:",
          "travelcase": {
            "empty": "Gratis travelcase",
            "black": "Zwarte travelcase",
            "red": "Rode travelcase",
            "silver": "Zilveren travelcase",
            "burgundy": "Burgundy travelcase",
            "pink": "Roze travelcase"
          },
          "discount": "{{ amount }} korting",
          "featured_product": "Verrassingsparfum van de maand",
          "surprise_perfume": "Verrassingsparfum",
          "no": "Sluiten",
          "yes": "Bevestig je keuze"
        }
      }
    },
    "activate_account": {
      "title": "Activeer account ",
      "subtext": "Maak wachtwoord aan om account te activeren",
      "password": "Wachtwoord",
      "password_confirm": "Bevestig wachtwoord",
      "submit": "Activeer account",
      "cancel": "Weiger uitnodiging"
    },
    "addresses": {
      "title": "Accountgegevens",
      "personal": "Persoonlijke gegevens",
      "shipping": "Verzendgegevens",
      "default": "Standaard",
      "first_name": "Voornaam",
      "last_name": "Achternaam",
      "company": "Bedrijfsnaam",
      "house_number": "Huisnummer",
      "address1": "Straat",
      "address2": "Adres2",
      "city": "Plaats",
      "country": "Land",
      "province": "Provincie",
      "zip": "Postcode",
      "postal_area": "Postcode of gemeente",
      "phone": "Telefoon",
      "optional": "(Niet verplicht)",
      "prefill_check": "Klopt je adres niet? Klik dan hier om het handmatig aan te passen.",
      "set_default": "Maak standaard adres",
      "search": "Zoek adres",
      "not_found": "Adres niet gevonden",
      "did_you_mean": "Bedoel je",
      "add": "Voeg adres toe",
      "update": "Sla op",
      "cancel": "Annuleer",
      "edit": "Wijzig",
      "delete": "Verwijder"
    },
    "login": {
      "title": "Log in",
      "email": "Email",
      "password": "Wachtwoord",
      "forgot_password": "Wachtwoord vergeten?",
      "sign_in": "Log in",
      "cancel": "Keer terug als gast",
      "guest_title": "Ga door als gast",
      "guest_continue": "Ga door"
    },
    "orders": {
      "title": "Je bestelgeschiedenis",
      "order_number": "Order",
      "date": "Datum",
      "payment_status": "Status betaling",
      "fulfillment_status": "Status verzending",
      "total": "Totaal",
      "none": "Je hebt nog geen parfum bij ons besteld"
    },
    "order": {
      "title": "Order {{ name }}",
      "date": "Geplaatst op {{ date }}",
      "cancelled": "Order gecancelled op {{ date }}",
      "cancelled_reason": "Reden: {{ reason }}",
      "billing_address": "Factuur adres",
      "payment_status": "Status betaling",
      "shipping_address": "Verzend adres",
      "fulfillment_status": "Order status",
      "discount": "Korting",
      "shipping": "Verzenden",
      "tax": "BTW",
      "product": "Product",
      "sku": "SKU",
      "price": "Prijs",
      "quantity": "Aantal",
      "total": "Totaal",
      "fulfilled_at": "Verwerkt op {{ date }}",
      "subtotal": "Subtotaal"
    },
    "upcoming": {
      "title": "Aankomende parfums",
      "description": "Wijzig hier de volgorde van je bestellingen of pauzeer de maanden dat je geen parfum wilt ontvangen. Je kunt maximaal 3 maanden overslaan.",
      "empty": "Geen parfum gekozen",
      "shipped": "Al verzonden",
      "activate": "Activeer deze maand",
      "skip": "Sla deze maand over",
      "skipped": "je abonnement staat voor deze maand op pauze",
      "not_skippable": "Vanaf volgende maand weer over te slaan"
    },
    "recover_password": {
      "title": "Reset je wachtwoord",
      "email": "Email",
      "submit": "Verzend",
      "cancel": "Annuleer",
      "subtext": "We sturen je een e-mail met daarin een link om je wachtwoord te resetten.",
      "success": "We hebben je een e-mail gestuurd met daarin een bevestiging."
    },
    "reset_password": {
      "title": "Reset account wachtwoord",
      "subtext": "Voer een wachtwoord in voor {{ email }}",
      "password": "Wachtwoord",
      "password_confirm": "Bevestig wachtwoord",
      "submit": "Reset wachtwoord"
    },
    "register": {
      "title": "Maak gratis account aan",
      "description": "Ontdek ons complete aanbod merkparfums",
      "first_name": "Voornaam",
      "last_name": "Achternaam",
      "email": "Email",
      "gender": "Geslacht",
      "male": "Man",
      "female": "Vrouw",
      "terms_html": "Door op onderstaande knop te klikken accepteer je onze <a href=\"\/pages\/algemene-voorwaarden\">voorwaarden<\/a>.",
      "accepts_marketing": "Ja, ik wil graag de parfum quiz kunnen doen, persoonlijke aanbevelingen krijgen en op de hoogte worden gehouden van het laatste nieuws van Parfumado.",
      "password": "Wachtwoord",
      "submit": "Maak aan",
      "or": "Of",
      "have_account": "Heb je al een account?"
    },
    "payment_method": {
      "title": "Betaalgegevens",
      "label": "Betaalmethode",
      "active": "Dit bedrag wordt op de {{ date }} afgeschreven",
      "gifted": "Giftcard van {{ duration }} maanden",
      "gifted_months_left": "Je giftcard is nog {{ duration_left }} maanden geldig.",
      "prepaid": {
        "initial_duration": "Je hebt {{ months }} maanden vooruit betaald voor je abonnement.",
        "months_left": "Je hebt nog {{ months_left }} maanden over. Daarna gaat je abonnement om naar maandelijkse betalingen van €14,95."
      }
    },
    "open_charges": {
      "title": "Openstaande betalingen",
      "reminder": "Herinneringskosten van {{ amount }}",
      "payment": "Incasso op {{ date }} van {{ amount }}",
      "call_to_action": "Openstaande betalingen voldoen"
    },
    "missing_mandate": {
      "title": "Mislukte betaling Parfumado",
      "info": "Via onderstaande betaallink kun je het openstaande bedrag van {{ amount }} naar ons overmaken.  Omdat jouw bank de incasso heeft geweigerd om onbekende redenen, of omdat je ervoor hebt gekozen om een betaling te storneren, hebben wij niet langer toestemming voor een automatische incasso van het maandelijkse abonnementsgeld.  Hieronder dien je dus opnieuw toestemming te geven voor toekomstige automatische afschrijvingen als je je abonnement wilt continueren. Indien je dit niet wenst, kun je hieronder ook voor de optie \"voldoe bedrag en stop abonnement\" kiezen.",
      "warning": "Let op: als je toestemming geeft voor de automatische maandelijkse afschrijvingen, zullen we de betaalmethode gebruiken die je nu kiest om je openstaande bedrag te voldoen.",
      "accept": "Ja, ik geef toestemming voor de maandelijkse afschrijvingen (en ik kan mijn abonnement ieder moment opzeggen of pauzeren).",
      "restart": "Betaal en start opnieuw",
      "stop": "Voldoe bedrag en stop abonnement"
    },
    "calendar": {
      "title": "Parfumkalender",
      "add_collection": "Voeg collectie toe",
      "add_product": "Voeg toe aan kalender",
      "login": "Meld je aan om toe te voegen",
      "items": {
        "empty": "Selecteer parfum voor deze maand",
        "paused": "Deze maand is overgeslagen",
        "remove": "Verwijder"
      },
      "info": {
        "many": "Nog {{ count }} dagen totdat je parfumkeuze definitief wordt",
        "one": "De laatste dag om je parfumkeuze te wijzigen",
        "today": "Je parfumkeuze wordt vandaag definitief, wijzigen kan nog!",
        "locked": "Je parfumkeuze is definitief geworden, we zijn deze aan het klaarmaken",
        "skipped": "Je keuze om deze maand te pauzeren is vastgezet",
        "shipping": {
          "delivery_with_count": "Over {{ count }} dag wordt deze naar je verzonden",
          "delivery_with_count_plural": "Over {{ count }} dagen wordt deze naar je verzonden"
        }
      }
    },
    "subscription": {
      "title": "Status",
      "label": "Abonnement status:",
      "paused": "Gepauzeerd",
      "active": "Actief",
      "inactive": "Inactief",
      "canceled": "Inactief",
      "pause": "Pauzeer abonnement",
      "activate": "Activeer abonnement",
      "cancel": "Beëindigen",
      "pause_popup": {
        "title": "Sla maand over",
        "description": "Je staat op het punt om je bestelling voor de aankomende maand over te slaan, weet je dit zeker?",
        "yes": "Ja",
        "no": "Nee, ga terug"
      },
      "faq": {
        "title": "Meestgestelde vragen",
        "question1": "Wanneer wordt mijn eerste parfum verzonden?",
        "answer1": "Als je nu je abonnement start, zit je in verzendmoment {{ delivery_day }}. Je eerste parfum wordt {{ date }} naar je toegestuurd vanuit ons distributiecentrum. Het duurt meestal 2 werkdagen voordat het pakketje bij jou thuis is, en 3 werkdagen als je in België woont.",
        "question2": "Moet ik thuis zijn om mijn pakketje te ontvangen?",
        "answer2": "Nee, je hoeft niet thuis te blijven. Onze pakketjes passen gewoon door de brievenbus, fijn hè? Enige uitzondering is wanneer je een beauty product bestelt - deze worden in een doosje verstuurd.",
        "question3": "Kan ik mijn aankomende parfumkeuze wijzigen?",
        "answer3": "Ja, je kunt iedere maand tot 7 dagen voor verzending jouw keuze wijzigen, heel simpel door naar je parfumkalender te gaan en parfums toe te voegen of te verslepen. 7 dagen voor verzending wordt je keuze definitief, zodat wij voldoende tijd hebben jouw pakketje klaar te maken.",
        "question4": "Kan ik altijd mijn abonnement pauzeren of stopzetten?",
        "answer4": "Ja, zeker! Je kunt je abonnement ieder moment stopzetten of pauzeren zoals het jou uitkomt. Omdat we weten dat soms een maandje overslaan best heel fijn kan zijn! Let op, doe dit wel 7 dagen voor verzending, als je die maand geen parfum wilt ontvangen.",
        "question5": "Wanneer wordt het bedrag afgeschreven?",
        "answer5": "Het bedrag wordt maandelijks rond je verzenddatum afgeschreven."
      },
      "checkout": {
        "packages": {
          "1_months": "Maandelijks voor €14,95",
          "6_months": "6 maanden voor €12,95",
          "12_months": "12 maanden voor €10,95"
        },
        "phone": {
          "hint": "Voor informatie over bezorgingen",
          "tooltip": "Mocht er onverhoopt iets wijzigen aan de status van je bestelling nemen we contact met je op. Zeer sporadisch bellen we klanten met de vraag wat er beter zou kunnen aan onze service."
        },
        "current_user": {
          "title": "Account",
          "user": "Ingelogd als: {{ email }}",
          "logout": "Ben je dit niet?"
        },
        "validation": {
          "discount": "Code is ongeldig",
          "invalid": "Ongeldige invoer",
          "solve": "Los de onderstaande problemen op en verstuur het formulier opnieuw"
        },
        "gift": {
          "order_with_count": "Parfumado giftset voor {{ count }} maand",
          "order_with_count_plural": "Parfumado giftset voor {{ count }} maanden",
          "discount_code": "Kortingscode",
          "step1": {
            "title": "Verzendwijze",
            "submit": "Maak je giftcard persoonlijk",
            "delivery_option": {
              "address_recipient": "Giftcard rechtstreeks aan ontvanger sturen",
              "address_buyer": "Giftcard zelf overhandigen",
              "email_recipient": "Verstuur de giftcardcode via email naar cadeau ontvanger",
              "email_buyer": "Verstuur de giftcardcode via email naar jezelf"
            },
            "invoice": {
              "address_buyer": "Adresgegevens cadeaugever",
              "buyer_description": "Vul hier je eigen adres in",
              "address_recipient": "Adresgegevens ontvanger",
              "recipient_description": "Vul hier het adres in van de ontvanger"
            }
          },
          "step2": {
            "submit": "Ga door naar betaling",
            "back": "terug naar verzendwijze",
            "message_option": {
              "title": "Maak het persoonlijk",
              "scripted": "Kaartje met voorgeschreven tekst",
              "personal_recipient": "Kaartje met persoonlijke boodschap (handgeschreven door Parfumado team)",
              "personal_buyer": "Kaartje om zelf te beschrijven"
            },
            "scripted_message": {
              "title": "Kies de boodschap",
              "options": {
                "1": "Dank je wel voor alles",
                "2": "Omdat je het verdient",
                "3": "Happy Birthday",
                "4": "Je weet wel waarom...",
                "5": "Snel beter worden",
                "6": "Speciaal voor jou",
                "7": "Omdat ik van je hou",
                "8": "You mean the world to me",
                "9": "Smell nice!"
              }
            },
            "personal_message": {
              "to_recipient": {
                "title": "Schrijf een persoonlijke boodschap",
                "description": "Typ hier je boodschap van max 30 tekens"
              },
              "to_buyer": {
                "title": "Kaartje om zelf te beschrijven",
                "description": "Je ontvangt een mooi, basic kaartje thuisgestuurd dat je zelf kunt beschrijven."
              }
            },
            "giver": {
              "title": "Laat weten wie het cadeau geeft",
              "giver_full_name": "Naam cadeau gever(s)",
              "recipient_name": "Naam cadeau ontvanger",
              "email_buyer": "Email cadeau gever",
              "email_buyer_direct_send": "Email cadeau gever - hier wordt de code naartoe verzonden",
              "email_recipient_direct_send": " Email cadeau ontvanger - hier wordt de code naartoe verzonden"
            }
          }
        },
        "first_package": "Jouw eerste pakketje",
        "permission": "Ja, ik geef toestemming voor maandelijkse afschrijvingen. Deze kun je altijd stopzetten of per maand wijzigen.",
        "confirmation": {
          "subscription": "Parfumado abonnement",
          "title": "Je huidige keuze voor de eerste maand",
          "subtitle": "Je parfumkeuzes kun je altijd na inschrijving nog wijzigen.",
          "item": "{{ count }} item aan parfumkalender toegevoegd",
          "item_plural": "{{ count }} items aan parfumkalender toegevoegd",
          "empty_html": "Je parfumkalender is nog leeg. Als deze leeg blijft, ontvang je altijd de parfum van de maand van ons. Kies je liever zelf? Dat kan <a href=\"\/collections\/all\">hier<\/a>",
          "subscription_monthly": "Parfumado abonnement per maand",
          "subscription_1_months": "Parfumado abonnement per maand",
          "subscription_6_months": "Parfumado abonnement voor 6 maanden",
          "subscription_12_months": "Parfumado abonnement voor 1 jaar",
          "subscription_afterwards": "Na afloop weer € 14,95 per maand (maandelijks opzegbaar)",
          "discount_code": "Kortingscode, giftcard of vriendencode",
          "subtotal": "Subtotaal",
          "discount": "Korting op je eerste maand",
          "travel_spray": "Travelspray",
          "travel_case": "Travelcase",
          "shipment": "Verzenden",
          "total": "Totaal inc BTW",
          "free": "Gratis"
        },
        "submit": {
          "processing": "Bezig met verwerken...",
          "gift": "Start mijn cadeau!",
          "payment": "Plaats order"
        }
      }
    },
    "activation": {
      "pending": {
        "title": "Hartelijk dank voor je betaling, we controleren nu de status van je betaling."
      },
      "success": {
        "title": "Je abonnement is nu actief! ",
        "subtitle": "We hebben je per mail een bevestiging gestuurd.",
        "heading1": "Verzenddatum",
        "paragraph1": "Je parfum wordt altijd op de {{ delivery_day }} van de maand naar je verzonden. Houd rekening met 3-7 werkdagen verzendtijd. Op de {{ payment_day }} wordt het bedrag van je rekening afgeschreven.",
        "heading2": "Wijzigen parfumkeuze",
        "paragraph2": "Vul jouw persoonlijke parfumkalender met je favorieten. Je kunt iedere maand tot 7 dagen voor de {{ delivery_day }} je parfumkeuze wijzigen. Als je geen keuze maakt, ontvang je het Parfum van de Maand.",
        "heading3": "Ontvang korting of cadeaus",
        "paragraph3": "Draag een vriend(in) aan met je persoonlijke code en krijg 50% korting op je volgende maand, een extra parfum of extra travelcase. De code geeft je vriend(in) ook 50% korting op zijn \/ haar eerste maand.",
        "footerText": "Onze parfum accessoires ontdekken?",
        "returnButtonText": "Ga naar de shop"
      },
      "failed": {
        "title": "Helaas! Je betaling was niet succesvol.",
        "retry": "Probeer het nog een keer"
      }
    },
    "cancel": {
      "title": "Beëindigen van je abonnement",
      "description1": "Als je doorgaat, wordt jouw abonnement stopgezet.",
      "description2": "Wist je dat je je abonnement ook meerdere maanden kunt pauzeren? Klik dan hier:",
      "skip_month": "Sla maand(en) over",
      "description3": "Weet je zeker dat je wilt stoppen?",
      "no": "Nee, ga terug",
      "yes": "Ja, stop",
      "popup": {
        "title": "Abonnement beëindigen",
        "description": "Je staat op het punt om je abonnement voor goed te beëindigen, weet je dit zeker?",
        "already_locked_html": "Let op, omdat je je abonnement stopzet tijdens een lock-moment, ontvang je je eerstvolgende parfum <strong>{{ perfume_name }}<\/strong> wél nog. Tevens is of wordt het geld hiervoor in rekening gebracht",
        "yes": "Ja",
        "no": "Nee, ga terug",
        "reasons": {
          "perfumes_bad": "De parfums vallen tegen",
          "too_many_deliveries": "Ik ontvang het liefst elke twee maanden één parfum",
          "enough_perfume": "Ik heb voorlopig voldoende parfum",
          "chargeback": "Mijn abonnement is stopgezet omdat ik het afgeschreven bedrag heb gestorneerd",
          "too_expensive": "Ik vind het abonnement te duur",
          "bad_customer_service": "Ik ben niet tevreden met de klantenservice",
          "other": "Geen van bovenstaande redenen"
        }
      },
      "popup_with_refund": {
        "title": "Abonnement beëindigen",
        "description": "Je staat op het punt om je abonnement te beëindigen, maar je hebt nog niets ontvangen. Als je nu stopt, ontvang je géén parfum! De initiële kosten zullen teruggestort worden. Weet je dit zeker?",
        "yes": "Ja",
        "no": "Nee, ga terug"
      }
    }
  },
  "homepage": {
    "sections": {
      "frontpage_title": "Frontpage Collection",
      "featured_title": "Featured Collections",
      "news_title": "Latest News"
    },
    "onboarding": {
      "modal_title": "Bijna voltooid...",
      "no_products_html": "You have no products in your home page collection. This placeholder will appear until you <a href=\"\/admin\/collections?tutorial=Frontpage\">add a product to this collection<\/a>.",
      "add_product": "Voeg een product toe",
      "product_title": "Example Product Title",
      "no_collections_html": "You don't have any collections to show here. <a href=\"\/admin\/custom_collections\">Add some collections<\/a> to go along with the default home page.",
      "add_collection": "Voeg collectie toe",
      "collection_title": "Example Collection Title"
    }
  },
  "layout": {
    "navigation": {
      "menu": "Menu"
    },
    "drawers": {
      "browse": "Zoek",
      "close_menu": "Sluit menu"
    },
    "cart": {
      "title": "Winkelwagen",
      "items_count": {
        "one": "item",
        "other": "items"
      }
    },
    "customer": {
      "account": "Account",
      "logged_in_as_html": "Ingelogd als {{ first_name }}",
      "log_out": "Log uit",
      "log_in": "Log in",
      "no_account": "Heb je nog geen account?",
      "create_account": "Maak Account"
    },
    "footer": {
      "social_title": "volg @parfumado",
      "review": "Beoordeeld met een 5.0",
      "newsletter_title": "Nieuwsbrief",
      "accepted_payments": "Geaccepteerde betalingsmethoden"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Vorig Product",
      "next_product_html": "Volgend Product &rarr;",
      "from_text_html": "Van {{ price }}",
      "sale_price": "Aanbiedingsprijs",
      "regular_price": "Reguliere prijs"
    },
    "product": {
      "sold_out": "Uitverkocht",
      "on_sale": "In de sale",
      "on_sale_from_html": "<strong>On Sale<\/strong> from {{ price }}",
      "unavailable": "Niet beschikbaar",
      "compare_at": "Vergelijk",
      "quantity": "Aantal",
      "add_to_cart": "Voeg toe aan parfumkalender",
      "parfumado_approved": "Parfumado approved",
      "external_buy_link": "Koop hele fles",
      "product_description__header": "Product beschrijving",
      "product_description__truncate": "Read more",
      "product_description__truncate-less": "Read less",
      "how_it_works": "How it works",
      "associations": "Associaties",
      "style": "Stijl",
      "occasion": "Gelegenheid",
      "season": "Seizoen",
      "related_products": "Gerelateerde producten",
      "fragrance_family": "Geurfamilie"
    }
  },
  "packages": {
    "package_1": {
      "duration": "1",
      "duration_label": "Maandelijks",
      "price_per_month": "14,95 p\/m",
      "description": "Maandelijks pauzeerbaar of opzegbaar",
      "button_label": "Kies abonnement"
    },
    "package_2": {
      "duration": "6",
      "duration_label": "6-maanden",
      "price_per_month": "12,95 p\/m",
      "description": "Vernieuwt automatisch en komt met cadeautje",
      "button_label": "Kies abonnement"
    },
    "package_3": {
      "best_deal": "Beste deal",
      "duration": "12",
      "duration_label": "12-maanden",
      "price_per_month": "10,95 p\/m",
      "description": "Vernieuwt automatisch en komt met cadeautje",
      "button_label": "Kies abonnement"
    },
    "page": {
      "header_section": {
        "title": "Ontdek iedere maand een merkparfum naar keuze",
        "subtitle": "Kies heel flexibel jouw eigen abonnement en ontvang iedere maand een parfum"
      },
      "packages_section": {
        "slogan": "Heel flexibel",
        "title": "Kies jouw abonnement"
      },
      "extras_section": {
        "slogan": "Heel flexibel",
        "title": "Ontvang extra goodies"
      }
    }
  },
  "gift_cards": {
    "activation": {
      "pending": {
        "title": "Hartelijk dank voor je bestelling, we controleren nu de status van je betaling."
      },
      "success": {
        "title": "Je bestelling is succesvol geplaatst!",
        "line1": "Bedankt dat je iemand beter gaat laten ruiken met onze giftcard :)",
        "line2": "Bestellingen geplaatst voor half 3 worden dezelfde dag verzonden, anders de volgende dag.",
        "back": "TERUG NAAR DE HOMEPAGE"
      },
      "failed": {
        "title": "Helaas! Je betaling was niet succesvol.",
        "retry": "Probeer het nog een keer"
      }
    },
    "page": {
      "title": "Het cadeau dat iedere maand opnieuw verrast",
      "description": "Parfumado stuurt parfums die de ontvanger zélf uitkiest!",
      "call_to_action": "Bestel Giftset",
      "selling_points": {
        "title": "Nooit meer cadeaustress",
        "description": "Nooit meer cadeaustress, laat de ontvanger zélf kiezen!",
        "line1": "Iedere maand opnieuw keuze uit meer dan 400 parfums",
        "line2": "Laat de giftcard naar jezelf of direct naar de ontvanger sturen",
        "line3": "Personaliseer je cadeau met leuk kaartje"
      },
      "options": {
        "title": "Kies het aantal maanden dat je cadeau wilt doen",
        "description": "Nooit meer stress over het juiste cadeau, laat de ontvanger zélf kiezen",
        "shipping": "Gratis Verzending"
      },
      "faq": {
        "title": "Veelgestelde vragen",
        "question1": {
          "title": "Kan ik het cadeautje personaliseren?",
          "answer": "Jazeker! Wanneer je hebt gekozen hoeveel maanden je cadeau zou willen doen kom je in ons betaalmenu. Hier krijg je de mogelijkheid een persoonlijk tekstje te schrijven dat aan het doosje met de giftcard zal worden toegevoegd."
        },
        "question2": {
          "title": "Wordt de eerste parfum direct toegestuurd?",
          "answer": "Nee, we verzenden eerst het cadeaudoosje met daarin de giftcard en het persoonlijke tekstje. Wanneer de cadeauontvanger zich aanmeldt op onze website en start met het cadeau, wordt de eerste parfum toegestuurd op de 1e of de 15e van de maand (afhankelijk van de startdatum van het abonnement)."
        },
        "question3": {
          "title": "Loopt het cadeau automatisch door in een abonnement?",
          "answer": "Nee hoor! De ontvanger krijgt voor de laatste maand een mail van ons met daarin een bericht over het aflopende cadeau. Na het laatst ontvangen parfum stopt het abonnement automatisch, mits de ontvanger zelf het cadeau omzet in een abonnement."
        },
        "question4": {
          "title": "Hoelang duurt het voordat de giftcard thuis wordt bezorgd?",
          "answer": "Wanneer de bestelling is geplaatst op een werkdag voor 16:30 wordt deze diezelfde dag nog verzonden. Meestal is de giftcard dan de volgende dag in huis."
        }
      }
    },
    "issued": {
      "title": "Hier is je {{ value }} gift card van {{ shop }}!",
      "subtext": "Hier is je gift card!",
      "disabled": "Uitgeschakeld",
      "expired": "Verlopen op {{ expiry }}",
      "active": "Verloopt op {{ expiry }}",
      "redeem": "Gebruik deze code bij het afrekenen van je product",
      "shop_link": "Start met winkelen",
      "print": "Print",
      "add_to_apple_wallet": "Voeg toe aan Apple Wallet"
    }
  },
  "date_formats": {
    "month_day_year": "%B %d, %Y"
  },
  "January": "januari",
  "February": "februari",
  "March": "maart",
  "April": "april",
  "May": "mei",
  "June": "juni",
  "July": "juli",
  "August": "augustus",
  "September": "september",
  "October": "oktober",
  "November": "november",
  "December": "december",
  "shopify": {
    "page_titles": {
      "products": "Onze parfums"
    }
  }
}